<template>
  <v-dialog :value="dialogState" max-width="960" @input="$emit('dialogEvent')">
    <v-card>
      <v-card-title class="text-h5 import-error-header">
        <div>
          <div class="import-error-title">Import validation failed</div>
          <div class="import-error-subtitle">
            Fix the listed spreadsheet issues and upload the file again.
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="error" outlined>
          {{ totalIssueRows }} rows with issues
        </v-chip>
        <v-btn color="black" text @click="$emit('dialogEvent')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-4">
        <v-row>
          <v-col
              v-for="(item, index) in importErrors"
              :key="index"
              cols="12"
              md="6"
          >
            <v-card class="mb-2 pa-1 import-error-row" elevation="1" outlined>
              <div class="import-error-row-title">Row {{ index }}</div>
              <v-list-item>
                <v-list-item-content>
                  <v-card
                      v-for="message in item"
                      :key="message"
                      class="mb-2 pa-2 import-error-item"
                      outlined
                  >
                    <v-icon class="mr-2" color="red">mdi-alert</v-icon>
                    <v-list-item-title v-html="message"></v-list-item-title>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('dialogEvent')">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["importErrors", "dialogState"],
  computed: {
    totalIssueRows() {
      return Object.keys(this.importErrors || {}).length;
    },
  },
};
</script>
<style scoped>
.import-error-header {
  background: linear-gradient(135deg, #fef2f2 0%, #fff7ed 100%);
  display: flex;
  gap: 12px;
  align-items: center;
}

.import-error-title {
  font-size: 22px;
  font-weight: 700;
  color: #7f1d1d;
}

.import-error-subtitle {
  font-size: 14px;
  color: #7c2d12;
  margin-top: 4px;
}

.import-error-row {
  border-radius: 14px;
  border-color: #fecaca !important;
}

.import-error-row-title {
  font-size: 18px;
  font-weight: 700;
  color: #991b1b;
  padding: 12px 16px 0;
}

.import-error-item {
  border-radius: 10px;
  border-color: #fee2e2 !important;
  background: #fffafa;
}
</style>
